import React from "react";
import "./Secondhero.scss";

import kiriatas from "../../../Media/fotoabout/kiriatas.webp";
import kiribawah from "../../../Media/fotoabout/kiribawah.webp";
import kananatas from "../../../Media/fotoabout/kananatas.webp";
import kananbawah from "../../../Media/fotoabout/kananbawah.webp";

const SecondHero = () => {
  return (
    <div className="secondherocontainer" id="about">
      <div className="secondmiddle">
        <div className="leftcontent">
          <div className="content-judul">
            <h1>Elevate Your Business </h1>
            <h2>with the Ideal Spaces</h2>
          </div>
          <div className="contentdescription">
            Selamat Datang, Kami siap membantu anda dalam mengembangkan bisnis
            anda. Dengan banyaknya pilihan ruko yang kami tawarkan, kami dapat
            membantu anda dalam pertumbuhan bisnis anda. Area Komersil yang kami
            tawarkan dapat anda sesuaikan dengan kebutuhan bisnis anda, mulai
            untuk membangun bisnis retail, untuk investasi anda serta untuk
            kantor impian anda. Area Komersil yang kami tawarkan memiliki
            kelebihan secara lokasi yang strategis, lokasi yang mudah diakses,
            dikelilingi oleh banyak Cluster Residential, serta dengan kurang
            lebih 200ribu penghuni sekitar area komersil. Lokasi Area Komersil
            yang kami tawarkan mulai dari Bumi Serpong Damai (BSD), Gading
            Serpong dan sekitarnya.
          </div>
        </div>
        <div className="rightcontent">
          <div className="leftpicture">
            <div className="kiriatas">
              <img src={kiriatas} className="satu" alt="Nava" />
            </div>
            <div className="kiribawah">
              <img src={kiribawah} className="dua" alt="Nava" />
            </div>
          </div>
          <div className="rightpicture">
            <div className="kananatas">
              <img src={kananatas} className="tiga" alt="Nava" />
            </div>
            <div className="kananbawah">
              <img src={kananbawah} className="empat" alt="Nava" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondHero;
